/**
 * Utility functions for user confirmations and prompts
 */

/**
 * Show confirmation dialog
 */
export const confirmAction = (message, title = 'Confirm Action') => {
  return window.confirm(message);
};

/**
 * Show prompt dialog
 */
export const promptUser = (message, defaultValue = '') => {
  return window.prompt(message, defaultValue);
};

/**
 * Show alert dialog
 */
export const alertUser = (message) => {
  return window.alert(message);
};

/**
 * Confirmation messages for common actions
 */
export const CONFIRMATION_MESSAGES = {
  CANCEL_EVENT: 'Are you sure you want to cancel this event?',
  CLONE_EVENT:
    'Are you sure you want to clone this event? Please pay attention to the dates as they will be empty or dummy in the cloned event.',
  DELETE_EVENT: 'Are you sure you want to delete this event?',
  RESET_LAYOUT: 'Are you sure you want to reset the layout?',
  APPROVE_PAYMENT: 'Are you sure you want to approve the payment for this event?',
  MAKE_PAYMENT: 'Are you sure you want to make the payment for this event?',
};

/**
 * Prompt messages for common actions
 */
export const PROMPT_MESSAGES = {
  PAYMENT_NOTE: (isApproved) =>
    `Current status of the payment is: ${isApproved ? 'APPROVED' : 'NOT APPROVED'}. Do you want to make the payment? You can also write an optional note.`,
};

export default {
  confirmAction,
  promptUser,
  alertUser,
  CONFIRMATION_MESSAGES,
  PROMPT_MESSAGES,
};
